var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.verifiSettingShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          {
            staticClass: "content",
            style: { height: _vm.getheight() },
            attrs: { id: "verificationSet" }
          },
          [
            _c("div", { staticClass: "title" }, [
              _vm._v(
                "\n                  " +
                  _vm._s(_vm.$t("language.twoStepverification.verifySet")) +
                  "\n                 "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.closePage()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _vm.stepOneShow
              ? _c("div", { staticClass: "set-body-content" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "calc(100% - 30Px)",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            height: "35Px",
                            width: "100%",
                            fontSize: "14Px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t(
                                  "language.twoStepverification.addWayVerify"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("cloud-select", {
                        ref: "cloudSelect",
                        staticStyle: { margin: "0 !important", float: "left" },
                        attrs: {
                          widthVal: 300,
                          selectOption: _vm.selectOption,
                          placeholder: _vm.selectValue
                        },
                        on: { changeOption: _vm.onChangeOption }
                      }),
                      _vm._v(" "),
                      _vm.emailInputShow
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailValue,
                                expression: "emailValue"
                              }
                            ],
                            staticClass: "ftp-cont-right-one",
                            staticStyle: {
                              width: "100%",
                              marginBottom: "10Px"
                            },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "language.twoStepverification.enterEmail"
                              )
                            },
                            domProps: { value: _vm.emailValue },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.emailValue = $event.target.value
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.emailInputShow
                        ? _c("cloud-select", {
                            ref: "phoneSelect",
                            staticStyle: {
                              margin: "10Px 0 0 0",
                              float: "left"
                            },
                            attrs: {
                              widthVal: 300,
                              selectOption: _vm.selectPhoneOption,
                              placeholder: _vm.selectPhoneValue
                            },
                            on: {
                              deleteSelectOption: _vm.showOtherOptions,
                              changeOption: _vm.onChangePhoneOption
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.emailInputShow
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.phoneValue,
                                expression: "phoneValue"
                              }
                            ],
                            staticClass: "ftp-cont-right-one",
                            staticStyle: {
                              width: "100%",
                              marginBottom: "10Px"
                            },
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "language.twoStepverification.enterPhone"
                              )
                            },
                            domProps: { value: _vm.phoneValue },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.phoneValue = $event.target.value
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.emailInputShow
                        ? _c("div", {
                            ref: "turnstileContainer",
                            staticClass: "turnstile-container"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShowTipByPhoneValue
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "red",
                                fontSize: "14px",
                                float: "left",
                                "text-algin": "left"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "language.twoStepverification.phoneValueTips"
                                  )
                                )
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.errorShow
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                color: "red",
                                fontSize: "14px",
                                float: "left",
                                "text-algin": "left"
                              }
                            },
                            [_vm._v(_vm._s(_vm.errorTxt))]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "30Px",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticStyle: { float: "right", width: "110Px" },
                          on: {
                            click: function($event) {
                              return _vm.sendCode()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.popup.reportPopup.next"))
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stepTwoShow
              ? _c("div", { staticClass: "set-body-content" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "calc(100% - 30Px)",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            width: "100%",
                            fontSize: "14Px",
                            lineHeight: "20Px"
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.$t("language.twoStepverification.enterCode")
                              ) +
                              " "
                          ),
                          _vm.emailValue
                            ? _c("b", { attrs: { title: _vm.emailValue } }, [
                                _vm._v(
                                  _vm._s(_vm._f("ellipsisNavi")(_vm.emailValue))
                                )
                              ])
                            : _vm._e(),
                          _vm.phoneValue
                            ? _c("b", { attrs: { title: _vm.phoneValue } }, [
                                _vm._v(
                                  _vm._s(_vm._f("ellipsisNavi")(_vm.phoneValue))
                                )
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.code,
                            expression: "code"
                          }
                        ],
                        staticClass: "ftp-cont-right-one",
                        staticStyle: {
                          width: "100%",
                          marginBottom: "10Px",
                          position: "relative"
                        },
                        style: { top: _vm.getTopPx() },
                        attrs: { type: "text", placeholder: "Code" },
                        domProps: { value: _vm.code },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.code = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.emailValue
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                float: "left",
                                width: "100%",
                                fontSize: "13Px",
                                lineHeight: "20Px"
                              }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t(
                                      "language.twoStepverification.enterCodeTip"
                                    )
                                  ) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "30Px",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticStyle: { float: "right", width: "110Px" },
                          on: {
                            click: function($event) {
                              return _vm.vrificationCode()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("language.popup.reportPopup.next"))
                          )
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.stepThreeShow
              ? _c("div", { staticClass: "set-body-content" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        height: "calc(100% - 30Px)",
                        float: "left"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            height: "20Px",
                            width: "100%",
                            fontSize: "14Px"
                          }
                        },
                        [
                          _c("b", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.twoStepverification.verificationTurnOn"
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            color: "#6f7886",
                            fontSize: "14Px",
                            marginTop: "10Px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.twoStepverification.recoverAccess"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            color: "#6f7886",
                            fontSize: "14Px",
                            marginTop: "10Px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.twoStepverification.longValid")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            color: "#6f7886",
                            fontSize: "14Px",
                            width: "100%",
                            marginTop: "10Px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.twoStepverification.newCode")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            float: "left",
                            fontSize: "14Px",
                            marginTop: "10Px",
                            corlor: "#000"
                          }
                        },
                        [_c("b", [_vm._v(_vm._s(_vm.recoveyCode))])]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "buttom-button" }, [
                    _c("div", { staticStyle: { width: "100%" } }, [
                      _c(
                        "button",
                        {
                          staticClass: "button-finish",
                          on: {
                            click: function($event) {
                              return _vm.finish()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.twoStepverification.finish")
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          style: { width: _vm.getCodeWidth() },
                          on: {
                            click: function($event) {
                              return _vm.copyCode($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("language.twoStepverification.copyCode")
                            )
                          )
                        ]
                      )
                    ])
                  ])
                ])
              : _vm._e()
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e562f5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e562f5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/verification_setting_popup.vue
// module id = null
// module chunks = 